import React from 'react';
import { IProps, IChildElement } from 'components/SliderMobile/types';
import Slider from 'components/Slider';

const SliderMobile: React.FC<IProps> & IChildElement = (props) => (
  <div className="slider-mobile">
    <Slider
      name={props.name}
      config={props.config}
      pagination={props.pagination}
    >
      {props.children}
    </Slider>
  </div>
);

SliderMobile.defaultProps = {
  pagination: false
};

SliderMobile.Item = Slider.Item;

export default SliderMobile;
